import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl } from "@mui/material"
import { useState } from "react"
import nztm from "nztm";
import { hikoAlert } from "../../../utils/HikoAlert";
import { GrayTextField } from "../../../utils/GrayTextField";

const nztmNorth = 6093600
const nztmSouth = 5971500
const nztmWest  = 1627000
const nztmEast  = 1746000

export function GPSCoordinatesDialog({open, onSave, onClose}) {
    
    const [easting, setEasting] = useState('')
    const [northing, setNorthing] = useState('')
    const [eastingErrorText, setEastingErrorText] = useState('')
    const [northingErrorText, setNorthingErrorText] = useState('')

    function convertNZTMtoWGS84(X, Y) { // E.g. 1738143.07, 6037195.38
        const { lt, ln } = nztm.nztm_geod(X, Y)
        const latitude = lt
        const longitude = ln > 180 ? 360-ln : ln
        return { latitude, longitude }
    }

    const handleGotoGPSLocation = (event) => {
        console.log('handleGotoGPSLocation')
        const {latitude, longitude} = convertNZTMtoWGS84(easting, northing)
        if (isNaN(latitude)) {
            hikoAlert("There was a problem with your Easting")
            return
        }
        if (isNaN(longitude)) {
            hikoAlert("There was a problem with your Northing")
            return
        }
        onSave(latitude, longitude)
    }

    const handleCancelClick = (event) => {
        console.log('handleCancelClick')
        onClose()
    }

    const handleChangeEasting = (newValue) => {
        console.log('newValue, nztmWest, nztmEast', newValue, nztmWest, nztmEast)
        setEasting(newValue)
        let newErrorText = ''
        if (isNaN(newValue)) {
            newErrorText = 'Please enter a number'
        } else if (newValue < nztmWest || newValue > nztmEast) {
            newErrorText = `Number range is ${nztmWest} to ${nztmEast}`
        }
        setEastingErrorText(newErrorText)
    }

    const handleChangeNorthing = (newValue) => {
        setNorthing(newValue)
        let newErrorText = ''
        if (isNaN(newValue)) {
            newErrorText = 'Please enter a number'
        } else if (newValue < nztmSouth || newValue > nztmNorth) {
            newErrorText = `Number range is ${nztmSouth} to ${nztmNorth}`
        }
        setNorthingErrorText(newErrorText)
    }

    const handlePaste = (e) => {
        // User has pasted text into the Easting text field
        const paste = e?.clipboardData?.getData("text") || ''
        const pasteList = paste.split(/[,\s]+/) // split on comma or whitespace
        if (pasteList.length === 2) {
            // Two elements in the pasted text, assume they are easting and northing
            e.preventDefault()
            handleChangeEasting(pasteList[0])
            handleChangeNorthing(pasteList[1])
        }
    }

    return (
        <Dialog open={open} onClose={handleCancelClick} scroll="paper" fullWidth>
            <DialogTitle>
                Enter GPS Coordinates
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{my: 1}}>
                    <FormControl sx={{mr: 2, mb: 2}}>
                        <GrayTextField
                            value={easting}
                            placeholder="E.g. 1718401"
                            label="Easting"
                            variant="outlined"
                            onChange={(e) => handleChangeEasting(e.target.value)}
                            onPaste={handlePaste}
                            error={!!eastingErrorText}
                            helperText={eastingErrorText}
                        >
                        </GrayTextField>
                    </FormControl>

                    <FormControl>
                        <GrayTextField
                            value={northing}
                            placeholder="E.g. 6043389"
                            label="Northing"
                            variant="outlined"
                            onChange={(e) => handleChangeNorthing(e.target.value)}
                            error={!!northingErrorText}
                            helperText={northingErrorText}
                        >
                        </GrayTextField>
                    </FormControl>


                </Box>
                
            </DialogContent>
            <DialogActions sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                <Button variant="contained" onClick={handleGotoGPSLocation} disabled={!!eastingErrorText || !!northingErrorText}>Goto GPS Location</Button>
                <Box sx={{marginLeft: 'auto'}}>
                    <Button onClick={handleCancelClick}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>
    )
}